package com.karawek.core.ui.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.karawek.core.ui.haptics.HapticType
import com.karawek.core.ui.haptics.LocalHapticsEnabled
import com.karawek.core.ui.haptics.performHapticIfEnabled

@Composable
fun CoreListItem(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val hapticsEnabled by rememberUpdatedState(LocalHapticsEnabled.current)

    Row(
        modifier = modifier
            .clickable {
                performHapticIfEnabled(hapticsEnabled, HapticType.Selection)
                onClick()
            }
            .padding(16.dp),
    ) {
        Text(text)
    }
}